import { date } from 'quasar'
import { cloneDeep } from 'lodash'

import { firstBy } from "thenby";

export function buildByDate (tenantAttendances) {
    const attendancesGroupedByDate = {}

    tenantAttendances.forEach((t, _) => {
        const tenant = t.tenant
        const attendances = t.profissionais

        attendances.forEach((profissional, _) => {

            if (!profissional.atendimentos)
                return

            profissional.atendimentos.forEach((atendimento, _) => {

                atendimento.horariosDisponiveis?.forEach((horario, _) => {
                    const data = horario.data

                    if (!(data in attendancesGroupedByDate))
                        attendancesGroupedByDate[data] = []

                    if (!attendancesGroupedByDate[data].filter(p => p.profissional.codigo == profissional.profissional.codigo).length) {
                        const newProfissional = cloneDeep(profissional)
                        const newTenant = cloneDeep(tenant)
                        newProfissional['tenant'] = newTenant

                        attendancesGroupedByDate[data].push(newProfissional)
                    }

                })

            })

        })
    })

    return attendancesGroupedByDate
}

export function buildByDateWithHorarios (attendancesGroupedByDate) {

    Object.entries(attendancesGroupedByDate).forEach(([data, profissionais]) => {

        profissionais.forEach((profissional, _) => {

            if (!profissional.atendimentos)
                return

            profissional.atendimentos.forEach((atendimento, _) => {

                const horarios = atendimento.horariosDisponiveis?.find(t => t.data == data)

                atendimento.horarios = horarios ? horarios.horarios : []

                delete atendimento.horariosDisponiveis
            })
        })

    })

    return attendancesGroupedByDate
}

export function buildFullDaysOrNotAvaible (sortedGrouped) {

    const dates = Object.keys(sortedGrouped).map(d => d.replaceAll("-", "/"))
    const maxDate = dates.reduce(function (a, b) { return a > b ? a : b; });
    const minDate = dates.reduce(function (a, b) { return a < b ? a : b; });

    const allDaysTodayToMaxDate = []
    //let nextDate = new Date();
    const maskDate = 'YYYY/MM/DD'

    let nextDate = date.extractDate(minDate, maskDate)

    const formatDate = d => date.formatDate(d, maskDate)

    allDaysTodayToMaxDate.push(formatDate(nextDate))
    while (maxDate > formatDate(nextDate)) {
        nextDate = date.addToDate(nextDate, { days: 1 })
        allDaysTodayToMaxDate.push(formatDate(nextDate))
    }

    return allDaysTodayToMaxDate.filter(day => !dates.includes(day));
}

export function sortAttendances (obj) {

    const reduceMin = obj => obj.reduce(function (a, b) { return a < b ? a : b; })
    const sumTotalAvailable = obj => obj.map(att => att.horarios.length).reduce((acc, element) => acc + element, 0)

    return Object.keys(obj).sort().reduce(function (result, key) {
        result[key] = obj[key]

        // Sort Professionals
        result[key].sort(
            firstBy(function (v) {
                return reduceMin(v.atendimentos.map(att => reduceMin(att.horarios)))
            }).thenBy(function (v) {
                return sumTotalAvailable(v.atendimentos)
            }, -1).thenBy(function (v) {
                return v.profissional.nome
            }, { ignoreCase: true })
        )

        // Sort Attendances
        result[key].forEach(p => {
            p.atendimentos.sort(
                firstBy(function (v) {
                    return reduceMin(v.horarios)
                }).thenBy(function (v) {
                    return v.horarios.length
                }, -1).thenBy(function (v) {
                    return v.nome
                }, { ignoreCase: true })
            )
        })

        /* 
        result[key].sort(function (a, b) {

            const minA = reduceMin(a.atendimentos.map( att => reduceMin(att.horarios)))
            const minB = reduceMin(b.atendimentos.map( att => reduceMin(att.horarios)))

            const totalA = sumTotalAvailable(a.atendimentos)
            const totalB = sumTotalAvailable(b.atendimentos)

            const nearestTime = minA.localeCompare(minB);
            const moreAvailable = totalA > totalB;
            const compareName = a.profissional.nome.localeCompare(b.profissional.nome);

            return nearestTime || moreAvailable || compareName;
        }.bind(this));
        */

        return result;
    }, {});
}